import { render, staticRenderFns } from "./CourseBuy.vue?vue&type=template&id=1e61b8cc&scoped=true"
import script from "./CourseBuy.vue?vue&type=script&lang=js"
export * from "./CourseBuy.vue?vue&type=script&lang=js"
import style0 from "./CourseBuy.vue?vue&type=style&index=0&id=1e61b8cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61b8cc",
  null
  
)

export default component.exports